export default {"src":"/_next/static/media/1.e50a35e2.svg","height":170,"width":305,"blurWidth":0,"blurHeight":0};